'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$6() {
  this.bUP = null;
  this.bUN = null;
  this.bUO = false;
  this.bUL = null;
  this.bUM = false;
  this.bUQ = false;
  this.bUR = false;
  this.bUP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$6 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$6 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$6;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$6() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$6 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$6 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bUP;
});
$p.t = (function() {
  if ((!this.bUO)) {
    this.bUN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("latitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("longitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("accuracy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bUO = true;
  }
  return this.bUN;
});
$p.ae = (function() {
  if ((!this.bUM)) {
    this.bUL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bUM = true;
  }
  return this.bUL;
});
$p.w = (function() {
  if ((!this.bUR)) {
    this.bUQ = false;
    this.bUR = true;
  }
  return this.bUQ;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$6, "presto.pages.envelopes.EnvelopesView$$anon$6", ({
  WC: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$6 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$6 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$6.js.map
